import { createBrowserRouter } from "react-router-dom";
import ProtectedLayout from "@/layouts/ProtectedLayout";
import Login from "@/pages/authentication/Login";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
import RoleManagement from "@/pages/master/role/RoleManagement";
import AuthorizationManagement from "@/pages/master/role/AuthorizationManagement";
import MaterialTypeManagement from "@/pages/master/material-type/MaterialTypeManagement";
import ProcessMasterManagement from "./pages/master/process/ProcessMasterManagement";
import MaterialSupplierManagement from "./pages/material-supplier/MaterialSupplierManagement";
import SystemMasterManagement from "./pages/master/system/SystemMasterManagement";
import MaterialCodeManagement from "./pages/material-supplier/MaterialCodeManagement";
import MaterialBasePriceManagement from "./pages/base-price/MaterialBasePriceManagement";
import ReturnScrapManagement from "./pages/return-scrap/ReturnScrapManagement";
import ReturnScrapMaster from "./pages/return-scrap/ReturnScrapMaster";
import FirstTierSupplierManagement from "./pages/first-tier-supplier/FirstTierSupplierManagement";
import PartManagement from "./pages/first-tier-supplier/PartManagement";
import NoPermission from "./pages/NoPermission";
import BreakdownManagement from "./pages/first-tier-supplier/BreakdownManagement";
import LogActivity from "./pages/log-activity/LogActivity";
import FlaggedPart from "./pages/flagged-part/FlaggedPart";
import ExchangeRateManagement from "./pages/exchange-rate/ExchangeRateManagement";
import ExchangeRateMaster from "./pages/exchange-rate/ExchangeRateMaster";
import BankManagement from "./pages/exchange-rate/BankManagement";
import BreakdownExchangeRate from "./pages/first-tier-supplier/BreakdownExchangeRate";
import BuyerBossManagement from "./pages/master/buyer-boss/BuyerBossManagement";
import ManualMasterPartManagement from "./pages/master/manual-part/ManualMasterPartManagement";
import AdminPage from "./pages/admin/AdminPage";
import PAPart from "./pages/pa/PAPart";
import PASupplier from "./pages/pa/PASupplier";

const router = createBrowserRouter([
  {
    element: <ProtectedLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/home", element: <Home /> },
      { path: "/dashboard", element: <Home /> },
      { path: "/simulation", element: <Home /> },
      { path: "/base-price", element: <MaterialBasePriceManagement /> },
      { path: "/breakdown", element: <FirstTierSupplierManagement /> },
      { path: "/breakdown/:supplierCode", element: <PartManagement /> },
      {
        path: "/breakdown/:supplierCode/:version/:partId",
        element: <BreakdownManagement />,
      },
      {
        path: "/breakdown/:supplierCode/exchange-rate",
        element: <BreakdownExchangeRate />,
      },
      { path: "/flagged-part", element: <FlaggedPart /> },
      { path: "/pa-part", element: <PAPart /> },
      { path: "/pa-supplier", element: <PASupplier /> },
      { path: "/master-material", element: <MaterialTypeManagement /> },
      { path: "/material-supplier", element: <MaterialSupplierManagement /> },
      {
        path: "/material-supplier/material-code/:materialSupplierId",
        element: <MaterialCodeManagement />,
      },
      { path: "/return-scrap", element: <ReturnScrapManagement /> },
      { path: "/return-scrap/master", element: <ReturnScrapMaster /> },
      { path: "/exchange-rate", element: <ExchangeRateManagement /> },
      { path: "/exchange-rate/master", element: <ExchangeRateMaster /> },
      { path: "/exchange-rate/supplier", element: <BankManagement /> },
      { path: "/master-process", element: <ProcessMasterManagement /> },
      { path: "/master-system", element: <SystemMasterManagement /> },
      { path: "/master-role", element: <RoleManagement /> },
      { path: "/master-buyer-boss", element: <BuyerBossManagement /> },
      { path: "/master-manual-part", element: <ManualMasterPartManagement /> },
      {
        path: "/master-role/authorization",
        element: <AuthorizationManagement />,
      },
      { path: "/log", element: <LogActivity /> },
      { path: "/admin", element: <AdminPage /> },
    ],
  },
  { path: "/login", element: <Login /> },
  { path: "/no-permission", element: <NoPermission /> },
  { path: "*", element: <NotFound /> },
]);

export default router;
